module.exports = __webpack_public_path__ + "static/media/photo152.7cbbc23e.jpg";